<template>
    <router-view></router-view>
</template>

<script>
import SettingsStore from 'stores/settings/settingsStore';
export default {
    created() {
        this.$store.registerModule('settingsStore', SettingsStore);
    },
    beforeUnmount() {
        this.$store.unregisterModule('settingsStore');
    },
};
</script>
